/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusdeleted2Inputs */

const en_crosspostingstatusdeleted2 = /** @type {(inputs: Crosspostingstatusdeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

const de_crosspostingstatusdeleted2 = /** @type {(inputs: Crosspostingstatusdeleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöscht`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Crosspostingstatusdeleted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusdeleted2 = /** @type {((inputs?: Crosspostingstatusdeleted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusdeleted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusdeleted2(inputs)
	return de_crosspostingstatusdeleted2(inputs)
});
export { crosspostingstatusdeleted2 as "crosspostingStatusDeleted" }